import React from "react"
import { SimpleLayout } from "../components/layout"
import styles from "./circletext.module.css"

export default props => (
  <SimpleLayout
    style={{
      padding: "60px 0",
      paddingBottom: "40px",
      background: "white",
    }}
  >
    <div className={styles.circletextheader}>{props.children}</div>

    <div className={styles.circletext}>
      {props.data.map(({ image, text }) => (
        <div className={styles.circleflex}>
          <div className={styles.circle}>
            <img src={image} alt="" />
          </div>
          <h1 dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      ))}
    </div>
  </SimpleLayout>
)
